import React from "react";
import { useNavigate } from "react-router-dom";
import { Cloud, Plus } from "lucide-react";

const Navbar = ({ showAlert }) => {
  const navigate = useNavigate();

  const onLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
    showAlert({
      type: "success",
      title: "Success",
      message: "Logged out successfully.",
    });
  };

  const styles = {
    header: {
      padding: "20px 0",
      backgroundColor: "#fff",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    },
    container: {
      width: "100%",
      margin: "0 auto",
      padding: "0 20px",
      position: "relative",
      zIndex: 10,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    logo: {
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "28px",
      fontWeight: 700,
      color: "#d97706",
    },
    logoIcon: {
      width: "36px",
      height: "36px",
      color: "#d97706",
    },
    button: {
      backgroundColor: "#FFFDEA",
      color: "#d97706",
      border: "1px solid #facc15",
      padding: "7px 14px",
      borderRadius: "25px",
      fontWeight: 600,
      fontSize: "14px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      marginRight: "10px",
    },
  };

  return (
    <>
      <style>{`
        .nav-button:hover {
          background-color: #fff7c2;
          transform: translateY(-1px);
        }
      `}</style>

      <header style={styles.header}>
        <div style={styles.container}>
          {/* Logo */}
          <div style={styles.logo}>
            <Cloud style={styles.logoIcon} />
            <span>MinDrop</span>
          </div>

          {/* Buttons (token-gated) */}
          {localStorage.getItem("token") && (
            <div>
              <button
                style={styles.button}
                className="nav-button"
                data-bs-toggle="modal"
                data-bs-target="#addNoteModal"
              >
                <Plus size={17} style={{ marginRight: "6px" }} />
                Add Note
              </button>
              <button
                onClick={onLogout}
                style={styles.button}
                className="nav-button"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Navbar;
